import * as types from '@/store/mutationTypes';
import axios from 'axios';
import stbAPIGateway from '../../../services/stbAPIGateway/index';

export default {
  async setApiVersion({ commit }) {
    try {
      const { version } = await stbAPIGateway(axios.create(), process.env.API_URL).getHealthAlive();
      commit(types.SET_API_VERSION, version);
    } catch (err) {
      console.error(err);
    }
  },

  async setStbAxios({ commit }, axios) {
    commit('setStbAxios', axios);
  },

  setSilentAxiosError({ commit }, silentMode) {
    commit('setSilentAxiosError', silentMode);
  }
};
